import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Main = styled.div`
  display: grid;
  grid-template-columns: 1fr 60px;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
`;

export const WorkingHours = styled(Typography.Caption)`
  margin: 2px 0;
`;

export const Link = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.system.blue};
`;

export const Warning = styled.div`
  margin: 15px 0;
  padding: 15px;
  border-radius: 7px;
  background-color: #fff5f2;
  display: grid;
  grid-template-columns: 28px 1fr;
  align-items: center;
  gap: 15px;
  border: ${({ theme }) => `1px solid ${theme.palette.system.red}`};
`;

export const WarningTitle = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.system.red};
  margin-bottom: 5px;
`;

export const AddShopFavorite = styled.button<{ $isFavoritedLocal: boolean }>`
  padding: 17px 39px;
  border-radius: 14px;
  color: ${({ theme }) => theme.palette.system.blue};
  background: ${({ theme }) => theme.palette.system.lightBlue};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: 0;
  margin-bottom: 10px;

  ${({ $isFavoritedLocal }) =>
    $isFavoritedLocal &&
    css`
      color: ${({ theme }) => theme.palette.primary.labels};
      background: ${({ theme }) => theme.palette.secondary.background};
    `}
`;
